import { render } from "./ModalAssociateMem.vue?vue&type=template&id=0d57034d"
import script from "./ModalAssociateMem.vue?vue&type=script&lang=js"
export * from "./ModalAssociateMem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\htdocs\\cosmocoslab_live\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__